import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalShell({ title, subtitle, updated, children }) {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-400 hover:text-amber-500 mb-6">
        <ArrowLeft className="w-3 h-3" /> Back home
      </Link>
      <div className="text-amber-500 text-xs font-bold tracking-[0.3em] uppercase">{subtitle}</div>
      <h1 className="display text-4xl md:text-5xl mt-2">{title}</h1>
      <div className="text-xs uppercase tracking-widest text-neutral-500 mt-3">Last updated · {updated}</div>
      <div className="mt-10 space-y-6 text-neutral-200 leading-relaxed text-sm">{children}</div>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="display text-2xl text-amber-500 mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
